import API from 'services/TAPS_API';

export default function getData(statementId) {
  return API.request({
    method: 'GET',
    url: `/notification/1150117/${statementId}`,
  });
}
